import {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { useDispatch } from 'react-redux';
import { Checkbox } from 'antd';
import {
  IFilterObraOption,
  ISelectedObraFilter
} from 'Store/Notification/interfaces/INotificationState';
import { NotificationActions } from 'Store/Notification/Notification.actions';
import Search from 'Components/ShellHost/TopBar/Search/Search';
import Ellipsis from 'Components/UI/Ellipsis';
import { GetAvatar } from 'Utils/generateThumbnail';
import { Wrapper } from './styles';

export interface ITipoFilter {
  minWidth?: string;
  defaultSelectedKeys: number[];
  obras: IFilterObraOption[];
  propsFilter: any;
  selectedObraFilter?: ISelectedObraFilter;
  setSelectedObraFilter?: Dispatch<SetStateAction<ISelectedObraFilter>>;
  showFilter?: (display: boolean) => void;
}

const FilterObra: FC<ITipoFilter> = ({
  minWidth,
  defaultSelectedKeys,
  obras,
  propsFilter,
  selectedObraFilter,
  setSelectedObraFilter,
  showFilter
}) => {
  const dispatch = useDispatch();

  const searchRef = useRef<HTMLInputElement | null>(null);
  const [searchInput, setSearchInput] = useState<string>();
  const [selectedKeys, setSelectedKeys] = useState<number[]>([]);

  const filteredObras = useMemo(() => {
    if (searchInput) {
      return obras.filter((obra) => {
        return obra.name.toLowerCase().includes(searchInput.toLowerCase());
      });
    }
    return obras;
  }, [obras, searchInput]);

  const changeFilterValues = (value: number, checked: boolean) => {
    if (checked) {
      const newSelectedKeys = [...selectedKeys, value];
      propsFilter.setSelectedKeys(newSelectedKeys);
      setSelectedKeys(newSelectedKeys);
      if (setSelectedObraFilter) {
        setSelectedObraFilter(prev => ({
          ...prev,
          count: newSelectedKeys.length
        }));
      }
    } else {
      const index = selectedKeys.indexOf(value);
      selectedKeys.splice(index, 1);
      const newSelectedKeys = [...selectedKeys];
      propsFilter.setSelectedKeys(newSelectedKeys);
      setSelectedKeys(newSelectedKeys);
      if (setSelectedObraFilter) {
        setSelectedObraFilter(prev => ({
          ...prev,
          count: newSelectedKeys.length
        }));
      }
    }
    propsFilter.confirm();
    if (showFilter) {
      showFilter(true);
    }
  };

  useEffect(() => {
    if (defaultSelectedKeys.length > 0) {
      propsFilter.setSelectedKeys([...defaultSelectedKeys]);
      setSelectedKeys([...defaultSelectedKeys]);
      dispatch(NotificationActions.choseDefaultFilterObra([]));
      propsFilter.confirm();
    }
    if (selectedObraFilter?.clear && setSelectedObraFilter) {
      propsFilter.setSelectedKeys([]);
      setSelectedKeys([]);
      propsFilter.confirm({ closeDropdown: false });
      setSelectedObraFilter({
        count: 0,
        clear: false
      });
    }
  }, [
    defaultSelectedKeys,
    propsFilter,
    selectedObraFilter,
    setSelectedObraFilter,
    dispatch
  ]);

  return (
    <Wrapper minwidth={minWidth}>
      <Search
        ref={searchRef}
        placeholder="Buscar obra"
        className="searchTipo"
        value={searchInput}
        changeValue={setSearchInput}
      />
      <div className="tipoOptionsWrap">
        {filteredObras.map(({ id, name, thumb, image }) => (
          <div
            key={name}
            className="tipoOption"
            onClick={(e) => {
              e.currentTarget.getElementsByTagName('input').item(0)?.click();
            }}
          >
            <Checkbox
              className="checkbox"
              onChange={(props: any) =>
                changeFilterValues(props.target.value, props.target.checked)
              }
              checked={propsFilter.selectedKeys.includes(id)}
              value={id}
            />
            <GetAvatar
              name={name}
              thumbSrc={thumb}
              src={image}
              shape='circle'
              size='small'
            />
            <Ellipsis
              phrase={name}
              maxLength={29}
              className="tipoOptionName"
            />
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default FilterObra;
